import addHeader from './Api'
import { TEST } from '../../config/config'

const API_BASE = '/api/'

interface SubApplication {
  idApp: number
  appId: string
  subAppDescription: string
  id?: number
  subAppId?: number
  modules?: Array<any>
  appInformation?: any
  configId?: string
}

export const create = async (appData: SubApplication) => {
  const data = {
    appId: appData.appId,
    subAppDescription: appData.subAppDescription,
    test: TEST,
    active: true
  }
  return await fetch(API_BASE + 'subapplication-post/' + appData.idApp + '?companyId=1', {
    method: 'POST',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export const update = async (appData: SubApplication) => {
  const data = {
    subAppId: appData.id,
    subAppDescription: appData.subAppDescription,
    test: TEST,
    active: true,
    configId: appData.configId,
    appId: appData.appId,
    modules: appData.modules
  }
  return await fetch(API_BASE + 'subapplication-put/' + appData.idApp + '/' + appData.id + '?companyId=1', {
    method: 'PUT',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export const archiveOne = async (appData: SubApplication) => {
  const data = {
    subAppId: appData.subAppId,
    subAppDescription: appData.subAppDescription,
    test: TEST,
    active: false,
    configId: appData.configId,
    appId: appData.appId,
    modules: appData.modules
  }
  return await fetch(API_BASE + 'subapplication-put/' + appData.appInformation.parents.idApp + '/' + appData.subAppId + '?companyId=1', {
    method: 'PUT',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export const deleteOne = async (id: number, idApp: number) => {
  return await fetch(API_BASE + 'subapplication-delete/' + idApp + '/' + id + '?companyId=1', {
    method: 'DELETE',
    headers: addHeader()
  })
}
